import { render, staticRenderFns } from "./QaListItemDeleteAlertDialog.vue?vue&type=template&id=a0485f1c&scoped=true&"
import script from "./QaListItemDeleteAlertDialog.vue?vue&type=script&lang=js&"
export * from "./QaListItemDeleteAlertDialog.vue?vue&type=script&lang=js&"
import style0 from "./QaListItemDeleteAlertDialog.vue?vue&type=style&index=0&id=a0485f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0485f1c",
  null
  
)

export default component.exports